import {
    // FILE_UPLOAD,
    CREATE_ACTIVESHARABLELINKS,
    RETRIEVE_ACTIVESHARABLELINKS,
    RETRIEVEMENU_ACTIVESHARABLELINKS,
    UPDATE_ACTIVESHARABLELINKS,
    DELETE_ACTIVESHARABLELINKS,
} from "./type";
import ActiveSharableLinks from "../service/ActiveSharableLinks";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ActiveSharableLinks.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ActiveSharableLinks.create(data);
        dispatch({
            type: CREATE_ACTIVESHARABLELINKS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ActiveSharableLinks.fetchList(data);
        dispatch({
            type: RETRIEVE_ACTIVESHARABLELINKS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveMenu = (data) => async (dispatch) => {
    try {
        const res = await ActiveSharableLinks.fetchMenuList(data);
        dispatch({
            type: RETRIEVEMENU_ACTIVESHARABLELINKS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ActiveSharableLinks.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ACTIVESHARABLELINKS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ActiveSharableLinks.update(data);
        dispatch({
            type: UPDATE_ACTIVESHARABLELINKS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ActiveSharableLinks.changeStatus(data);
//         dispatch({
//             type: UPDATE_ACTIVESHARABLELINKS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ActiveSharableLinks.trash(data);
        dispatch({
            type: DELETE_ACTIVESHARABLELINKS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};